export default [
  {
    path: '/act-one-detail',
    name: 'actOneDetail',
    component: () => import('@/view/activities/wed-activities/act-one-detail.vue')
  },
  {
    path: '/act-one-rules',
    name: 'actOneRules',
    component: () => import('@/view/activities/wed-activities/act-one-rules.vue')
  },
  {
    path: '/act-two-detail',
    name: 'actTwoDetail',
    component: () => import('@/view/activities/wed-activities/act-two-detail.vue')
  },
  {
    path: '/act-two-rules',
    name: 'actTwoRules',
    component: () => import('@/view/activities/wed-activities/act-two-rules.vue')
  }
]